import React from 'react';
import { Radio, DatePicker, Picker } from 'antd-mobile';
import { appMethod as app } from '@utils/app';
import { convertLineStyleData, getCurrentPageQueryParams } from '@utils/tools';
import { getAppId } from '@utils/global';
import { ImgUpload } from '@common/img-upload/ImgUpload';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './UserCenter.less';

function format2Date(date) {
  const pad = n => n < 10 ? `0${n}` : n;
  const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  return `${dateStr}`;
}


const CoverThumb = (props) => (
  <div className="cover-thumb">
    <img src={props.url}/>
    <ImgUpload complete={(url) => props.change(url)}/>
  </div>
)

export default class UserCenter extends OfficialPage {
  state = {
    userInfo: {}, // 用户信息
    todayDate: '2018-8-10', // 今天的日期
    userCityArr: ['', ''], // 用户城市信息的集合   [country, pri, city]
    isGetPhoneNumber: false, // 是否获得手机授权
    isFromBack: false,
    collectConfig: {}, // 收集配置
    cardId: '', // 需要领取的会员卡id
    isNoConditionRecv: '', // 是否无门槛领卡
    franchisee: '', // 子店id
    backRouter: '', // 设置返回的路由
    isCantChangeBir: false, // 生日是否可改
    cityCol: 1,   // WEBAPP PICKER COL
    cityData: [], // WEBAPP 存放城市数据
  }
  constructor(porps) {
    super(porps);
    document.title = '个人信息';
  }
  componentWillMount = (options = getCurrentPageQueryParams()) => {
    let cardId = options.id || '' // 存在cardId即为会员信息保存，否则为个人信息（不校验必填项）
    let isMember = options.is_member || ''
    let isNoConditionRecv = options.is_no_condition_recv || ''
    let r = options.r || ''
    let franchisee = options.franchisee || ''
    this.setData({
      cardId: cardId || isMember,
      isNoConditionRecv: isNoConditionRecv,
      backRouter: r,
      franchisee: franchisee
    })
    if (this.data.cardId) {
      app.setNavigationBarTitle({
        title: '会员信息'
      })
    }
    this.getCollectUserinfoConfig()
    this.infoInit()
    this.getXcxUserInfo()
    this.getCityData(0);
  }
  componentDidShow = () => {
    if (this.data.isFromBack) {
      this.getXcxUserInfo()
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }
  getCollectUserinfoConfig = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=appVipCard/getCollectUserinfoConfig',
      method: 'post',
      data: {},
      hideLoading: false,
      success: function(res) {
        _this.setData({
          collectConfig: res.data
        })
      }
    })
  }
  getXcxUserInfo = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppData/getXcxUserInfo',
      success: res => {
        if (res.status == 0) {
          var data = res.data
          that.setData({
            'userInfo.phone': data.phone || ''
          })
        }
      }
    })
  }
  infoInit = () => {
    let date = new Date()
    let userInfo = app.getUserInfo()
    let userCityArr = ['']
    if (userInfo.birthday === '0000-00-00') {
      userInfo.birthday = ''
    }
    if (userInfo.province && userInfo.city) {
      userCityArr = [userInfo.province, userInfo.city]
    }
    this.setData({
      userInfo: userInfo,
      isCantChangeBir: userInfo.birthday && userInfo.birthday != '0000-00-00',
      userCityArr: userCityArr,
      isGetPhoneNumber: userInfo.phone ? true : false,
      todayDate:
        date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    })
  }
  choosePhoto = (url) => {
    var that = this
    that.setData({
      'userInfo.cover_thumb': url
    })
  }
  selectedSex = e => {
    this.setData({
      'userInfo.sex': e.target.value
    })
  }
  bindBirthdayChange = v => {
    let value = format2Date(v);
    this.setData({
      'userInfo.birthday': value
    })
  }
  bindCityChange = v => {
    this.setData({
      userCityArr: v
    })
  }
  inputUserInfo = e => {
    let setData = {}
    if (e.currentTarget.dataset.type === 'nickname') {
      setData = { 'userInfo.nickname': e.target.value }
    } else if (e.currentTarget.dataset.type === 'weixinCode') {
      setData = { 'userInfo.weixin_code': e.target.value }
    } else if (e.currentTarget.dataset.type === 'email') {
      setData = { 'userInfo.email': e.target.value }
    } else if (e.currentTarget.dataset.type === 'company') {
      setData = { 'userInfo.company': e.target.value }
    }
    this.setData(setData)
  }
  getPhoneNumber = e => {
    if (this.data.isGetPhoneNumber) {
      return
    }
    let _this = this
    app.checkSession(function() {
      if (!e.target.encryptedData) {
        return
      }
      app.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppUser/GetPhoneNumber',
        data: {
          encryptedData: e.target.encryptedData || '',
          iv: e.target.iv || ''
        },
        success: function(res) {
          app.setUserInfoStorage({
            phone: res.data
          })
          _this.setData({
            'userInfo.phone': res.data,
            isGetPhoneNumber: true
          })
        },
        successStatus5: function() {
          app.showModal({
            content: '获取手机号失败，请再次点击授权获取'
          })
          // app.goLogin({
          //   success: function() {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   },
          //   fail: function() {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   }
          // })
        }
      })
    })
  }
  bindCellphonePage = () => {
    let page_router = app.getAppCurrentPage().route.split('/').pop()
    if (this.data.cardId) {
      // TODO: 后续更改为bindCellphone
      app.turnToPage('bindCellphone?r=' + page_router + '&is_member=1', 1)
    } else {
      // TODO: 后续更改为bindCellphone
      app.turnToPage('bindCellphone?r=' + page_router, 1)
    }
  }
  saveUserInfo = e => {
    let data = this.data.userInfo
    let _this = this
    let config = this.data.collectConfig
    let params = {}
    let cardId = this.data.cardId
    if (cardId && !this.validate()) {
      return
    }
    if (data.email && !this.checkEmail(data.email)) {
      return
    }
    params.nickname = data.nickname
    params.phone = data.phone
    params.sex = data.sex
    params.birthday = data.birthday
    params.cover_thumb = data.cover_thumb
    config.collect_company != 0 ? (params.company = data.company) : ''
    config.collect_email != 0 ? (params.email = data.email) : ''
    if (config.collect_region != 0) {
      params.province = this.data.userCityArr[0]
      params.city = this.data.userCityArr[1]
    }
    config.collect_weixin_id != 0 ? (params.weixin_code = data.weixin_code) : ''
    cardId ? (params.formId = e.target.formId) : ''
    app.sendRequest({
      url: '/index.php?r=AppData/saveUserInfo',
      method: 'post',
      data: params,
      success: function(res) {
        if (res.status === 0) {
          app.setUserInfoStorage(params)
          if (_this.data.isNoConditionRecv) {
            _this.recvVipCard()
            return
          }
          _this.savedAction()
        }
      }
    })
  }
  validate = () => {
    let config = this.data.collectConfig
    let data = this.data.userInfo
    if (config.collect_phone == 2 && !data.phone) {
      app.showModal({
        content: '请完善手机号'
      })
      return false
    }
    if (
      config.collect_birthday == 2 &&
      (!data.birthday || data.birthday === '0000-00-00')
    ) {
      app.showModal({
        content: '请完善生日'
      })
      return false
    }
    if (config.collect_weixin_id == 2 && !data.weixin_code) {
      app.showModal({
        content: '请完善微信号'
      })
      return false
    }
    if (config.collect_email == 2 && !data.email) {
      app.showModal({
        content: '请完善邮箱'
      })
      return false
    }
    if (config.collect_company == 2 && !data.company) {
      app.showModal({
        content: '请完善公司'
      })
      return false
    }
    if (
      config.collect_region == 2 &&
      !this.data.userCityArr[0] &&
      !this.data.userCityArr[1]
    ) {
      app.showModal({
        content: '请完善地址'
      })
      return false
    }
    return true
  }
  savedAction = () => {
    app.showToast({
      title: this.data.cardId ? '领取成功' : '保存成功',
      icon: 'success'
    })
    setTimeout(() => {
      app.turnToPage(
        this.data.backRouter ||
          '/pages/userCenterComponentPage/userCenterComponentPage'
      )
    }, 1000)
  }
  checkEmail = email => {
    let str = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
    if (str.test(email)) {
      return true
    } else {
      app.showModal({
        content: '请填写正确的邮箱'
      })
    }
  }
  recvVipCard = () => {
    let _this = this
    app.sendRequest({
      data: {
        vipcard_id: _this.data.cardId,
        sub_shop_app_id: _this.data.franchisee
      },
      url: '/index.php?r=AppVipCard/RecvVipCard',
      hideLoading: true,
      success: res => {
        _this.savedAction()
      }
    })
  }
  times = 0
  time = ''
  getCityData = (id) => {
    app.sendRequest({
      data: {
        pid: id,
      },
      url: '/index.php?r=Region/getRegionList',
      success: res => {
        if (id === 0) {
          this.setData({
            'cityData': [
              {
                label: '暂未选择',
                value: '',
              },
              ...res.data.map(item => {
              return {
                id: item.id,
                label: item.name,
                value: item.name,
                children: []
              };
            })]
          });
        } else {
          let index = this.data.cityData.findIndex(province => province.id == id);
          if (index > -1) {
            this.setData({
              [`cityData[${index}].children`]: res.data.map(item => {
                return {
                  label: item.name,
                  value: item.name,
                }
              }) || [],
              'cityCol': 2
            })
          }
        }
        this.cityData = [];
      }
    })
  }
  handleCityDataLoad = (val) => {
    let arr = val;
    // 仅加载市级信息
    if (!arr[0] ||  arr[1]) {
      return;
    }
    this.setData({
      userCityArr: [...arr]
    })
    let index = this.data.cityData.findIndex(province => province.value == arr[0]);
    if (this.data.cityData[index].children.length === 0) {
      this.getCityData(this.data.cityData[index].id)
    }
  }

  logout = () => {
    app.showModal({
      content: '确定要退出登录?',
      confirm: () => {
        app.sendRequest({
          url: '/index.php?r=AppUser/logout',
          data: {
            app_id: getAppId(),
          },
          success: () => {
            app.setIsLogin(false);
            app.turnToPage(app.getHomepageRouter());
          }
        })
      },
      showCancel: () => {}
    })
  }

  render() {
    const {
      collectConfig,
      cardId,
      userInfo,
      todayDate,
      isCantChangeBir,
      userCityArr,
      cityCol,
      cityData,
    } = this.state
    return (
      <div className="content">
        <TopNav title="个人信息"/>
        <div className="info-wrapper">
          {(!cardId || (collectConfig.collect_username && collectConfig.collect_username !== '0')) && (
            <div className="info-item">
              <div className={'name ' + (collectConfig.collect_username === '2' && cardId ? 'star' : '')}>昵称</div>
              <div className="right-block">
                <input
                  style={{
                    width: '4.00rem'
                  }}
                  type="text"
                  placeholder="请填写昵称"
                  value={userInfo.nickname || ''}
                  data-type="nickname"
                  onInput={this.inputUserInfo}
                  onChange={() => {}}
                />
                <CoverThumb url={userInfo.cover_thumb} change={(url) => this.choosePhoto(url)}></CoverThumb>
                <div className="ico-moon icon-rightarrow"></div>
              </div>
            </div>
          )}
          {(!cardId || (collectConfig.collect_phone && collectConfig.collect_phone !== '0')) && (
            <div className="info-item">
              <div className={'name ' + (collectConfig.collect_phone === '2' && cardId ? 'star' : '')}>手机号</div>
              <div className="right-block" onClick={this.bindCellphonePage}>
                <div>{userInfo.phone || '请绑定手机号码'}</div>
                <div className="ico-moon icon-rightarrow"></div>
              </div>
            </div>
          )}
          {(!cardId || (collectConfig.collect_sex && collectConfig.collect_sex !== '0')) && (
            <div className="info-item">
              <div className={'name ' + (collectConfig.collect_sex === '2' && cardId ? 'star' : '')}>性别</div>
              <div className="right-block">
                <div className="radio-group">
                  <label className="radio">
                    <Radio
                      name="sex"
                      value="0"
                      color="#FF7100"
                      checked={userInfo.sex == 0}
                      onChange={(e) => this.selectedSex(e)}
                    >男</Radio>
                  </label>
                  <label className="radio">
                    <Radio
                      name="sex"
                      value="1"
                      color="#FF7100"
                      checked={userInfo.sex == 1}
                      onChange={(e) => this.selectedSex(e)}
                    >女</Radio>
                  </label>
                </div>
              </div>
            </div>
          )}
          {(!cardId || (collectConfig.collect_birthday && collectConfig.collect_birthday !== '0')) && (
            <div className="info-item birthday-info">
              <div className={'name ' + (collectConfig.collect_birthday === '2' && cardId ? 'star' : '')}>生日</div>
              <div className="right-block">
                <DatePicker
                  disabled={isCantChangeBir}
                  mode="date"
                  format="YYYY-MM-DD"
                  onChange={(v)=> this.bindBirthdayChange(v)}
                  minDate={new Date(1900, 1, 1, 0, 0, 0)}
                  maxDate={new Date(2030, 1, 1, 23, 59, 59)}
                  >
                  <div className="birthday-picker">
                    <div className="picker">{!userInfo.birthday
                        ? '请选择出生日期'
                        : userInfo.birthday}</div>
                  </div>
                </DatePicker>
                {!isCantChangeBir && (
                  <div className="ico-moon icon-rightarrow"></div>
                )}
                <div className="comment">注:生日保存之后不允许修改，请正确填写</div>
              </div>
            </div>
          )}
          {!!(collectConfig.collect_weixin_id && collectConfig.collect_weixin_id !== '0') && (
              <div className="info-item">
                <div className={'name ' + (collectConfig.collect_weixin_id === '2' && cardId ? 'star' : '')}>微信号</div>
                <div className="right-block">
                  <input
                    type="text"
                    placeholder="请填写微信号"
                    value={userInfo.weixin_code}
                    data-type="weixinCode"
                    onInput={this.inputUserInfo || ''}
                    onChange={() => {}}
                  />
                </div>
              </div>
            )}
          {!!(collectConfig.collect_email && collectConfig.collect_email !== '0') && (
              <div className="info-item">
                <div className={'name ' + (collectConfig.collect_email === '2' && cardId ? 'star' : '')}>邮箱</div>
                <div className="right-block">
                  <input
                    type="text"
                    placeholder="请填写邮箱"
                    value={userInfo.email || ''}
                    data-type="email"
                    onChange={this.inputUserInfo}
                  />
                </div>
              </div>
            )}
          {!!(collectConfig.collect_company && collectConfig.collect_company !== '0') && (
              <div className="info-item">
                <div className={'name ' + (collectConfig.collect_company === '2' && cardId ? 'star' : '')}>公司</div>
                <div className="right-block">
                  <input
                    type="text"
                    placeholder="请填写公司"
                    value={userInfo.company || ''}
                    data-type="company"
                    onInput={this.inputUserInfo}
                    onChange={() => {}}
                  />
                </div>
              </div>
            )}
          {!!(collectConfig.collect_region && collectConfig.collect_region !== '0') && (
              <div className="info-item ">
                <div className={'name ' + (collectConfig.collect_region === '2' && cardId ? 'star' : '')}>所在地</div>
                <div className="right-block">
                  <Picker
                    data={cityData}
                    value={userCityArr}
                    cols={cityCol}
                    onPickerChange={(val) => this.handleCityDataLoad(val)}
                    onOk={e => this.bindCityChange(e)}
                  >
                    <div className="picker" style={{
                      color: userCityArr[0] === '' ? '#999' : '#000'
                    }}>
                      {userCityArr[0] === '' ? '请填写所在城市' : userCityArr.join('')}
                    </div>
                  </Picker>
                  <div className="ico-moon icon-rightarrow"></div>
                </div>
              </div>
            )}
        </div>
        <div className="tip">请完善个人信息，以便我们为你提供更好的会员服务</div>
        <button className="save-btn" onClick={this.saveUserInfo}>{cardId ? '立即领取' : '保存'}</button>
        <button className="logout-btn" onClick={this.logout}>退出登录</button>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/official-page/user-center/UserCenter.jsx